import { render, staticRenderFns } from "./BizLevelUsage.vue?vue&type=template&id=6e20b22c&scoped=true"
import script from "./BizLevelUsage.vue?vue&type=script&lang=js"
export * from "./BizLevelUsage.vue?vue&type=script&lang=js"
import style0 from "./BizLevelUsage.vue?vue&type=style&index=0&id=6e20b22c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e20b22c",
  null
  
)

export default component.exports